import type { FaireProductEntity } from "../../entity_types/product";

export const p_8g7u63t7v2: FaireProductEntity = {
  token: "p_8g7u63t7v2",
  type: "product",
  name: "Screaming Chicken",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/66e966cafe1480531630416c59e182fd03afc6a7cfd4772c15173d49288c0d21.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.48,
  description: "Stop, flap your wings, and scream! Feeling a little stressed out? Your miniature 3½? inch chicken desktop companion helps you channel your frustration, calm your chaos, and let it all out in the most cathartic way possible—just give it a squeeze! This item includes a 3½-inch chicken figurine that sits in a nest, which lets out a truly unforgettable scream when squeezed. Additionally, it comes with a 32-page fully illustrated mini book (2 1/2 x 3 inches) about what chickens can teach us about how to survive, thrive—and scream through—the madness of modern life. It's the perfect gag gift for animal lovers, anyone who owns or admires chickens, or anyone who simply needs to scream. Includes button cell batteries.",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:34.817Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
